import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/taggedTemplateLiteralLoose';
import { css } from '@emotion/css';

var _templateObject;
var selectStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  .MuiInputBase-root,\n  .MuiAutocomplete-input {\n    cursor: pointer;\n  }\n\n  .MuiInputBase-input::selection {\n    background-color: transparent;\n  }\n\n  .MuiInputBase-input[readonly] {\n    -webkit-user-select: none;\n    user-select: none;\n  }\n"])));

export { selectStyles };
//# sourceMappingURL=styles.js.map
